<template>
  <div
    :class="['cpu-btn',disable?'cpu-btn__disable':'',touchActive?'cpu-btn__hover':'']"
    @touchstart="onTouchStart"
    @touchend="onTouchEnd"
  >
    {{text}}
  </div>
</template>
<script>
export default {
  data() {
    return {
      touchActive: false
    }
  },
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '按钮'
    }
  },
  methods: {
    onTouchStart() {
      if (!this.disable) {
        this.touchActive = true
      }
    },
    onTouchEnd() {
      this.touchActive = false
    }
  }
}
</script>
<style lang="less">
// 默认样式
.cpu-btn {
  width: 100%;
  height: 47px;
  line-height: 47px;
  background: #1ca9d9;
  color: #fff;
  text-align: center;
  font-size: 18px;
  &:hover {
    background: #1eb9ee;
  }
}
.cpu-btn__disable {
  background: #e7e7e7;
}
.cpu-btn__hover {
  background: #1eb9ee;
}
</style>


